export const initialState = {
  chatRooms: [],
  therapistChatRooms: [],
  messages: [],
  isChatConnected: false,
  isOnChatPage: false,
  subscribeIds: undefined,
  authToken: undefined,
  authUserId: undefined,
  tokenExpiredAt: null,
  selectedRoom: undefined,
  videoCall: undefined,
  callAccessToken: undefined,
  hasStartedCall: false,
  hasAcceptedCall: false,
  showIncomingCall: false,
  showAcceptedCall: false,
};
